import React from 'react'

export const Centered = ({ children }: { children: any }) => {
  return (
    <p className="mb-4 / text-primary text-xl font-bold text-center leading-snug">
      {children}
    </p>
  )
}
